<template>
  <v-card class="rounded-card card-shadow">
    <v-card-text class="text--primary pb-8 px-6">
      <template v-for="(pacote, index) in compra.pacotes">
        <div :key="index" class="mt-8">
          <px-compra-frete-marketplace class="body-1 font-weight-bold"
                                       :frete="pacote.frete"/>
          <px-compra-pacote-frete-padrao :pacote="pacote"/>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import CompraPacoteFretePadrao from './CompraPacoteFretePadrao.vue';

export default {
  props: {
    compra: Object,
  },
  computed: {
    isMelhorEnvio() {
      return (pacoteFrete) => pacoteFrete.modoFrete === 'MELHOR_ENVIO';
    },
  },
  components: {
    pxCompraPacoteFretePadrao: CompraPacoteFretePadrao,
  },
};
</script>
